import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import settings from './modules/settings'
import user from './modules/user'
import websocket from './modules/websocket'
import timer from './modules/timer'
import sdk from './modules/sdk'
import xiGuaPlayer from './modules/xiGuaPlayer'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    tagsView,
    settings,
    user,
    websocket,
    timer,
    sdk,
    xiGuaPlayer
  },
  getters
})

export default store
